//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilterCheckbox from "./Filter.vue";
import FilterLocation from "./FilterLocation.vue";
export default {
	name: "CaroFilters",
	components: {
		FilterCheckbox,
		FilterLocation
	},
	data() {
		return {
			url: null,
			params: null,
			mobileFilterShow: true,
			initialSpecialty: true,
			//iniitalLanguage: true,
			initialLocationType: true
		}
	},
	props: {
		filters: Array,
		results: Object,
		setFilterValue: Function,
		executeSearch: Function,
		extend: Function,
		extended: Object
	},
	computed: {
		locationModel: {
			get() {
				return this.extended?.location;
			},
			set(value) {
				this.extend(extended => {
					extended.location = value;
					return extended;
				})
			},
		},
		specialtyModel: {
			get() {
				if (!this.extended?.specialty?.value) return this.results.specialty.options[0].value
				else return this.extended?.specialty?.value;
			},
			async set(value) {
				this.extend(extended => {
					extended.specialty = this.results.specialty.options.find(o => o.value === value);
					return extended;
				})
				if (!this.initialSpecialty) {
					await this.executeSearch()
					this.deleteSpecialtyParam()
				};
			},
		},
		// languageModel: {
		// 	get() {
		// 		if (!this.extended?.language?.value) return this.results.language.options[0].value
		// 		else return this.extended?.language?.value;
		// 	},
		// 	async set(value) {
		// 		this.extend(extended => {
		// 			extended.specialty = this.results.language.options.find(o => o.value === value);
		// 			return extended;
		// 		})
		// 		if (!this.initialLanguage) {
		// 			await this.executeSearch()
		// 			this.deleteSpecialtyParam()
		// 		};
		// 	},
		// },
		locationTypeModel: {
			get() {
				if (!this.extended?.locationType?.value) return this.results.locationType.options[0].value
				else return this.extended?.locationType?.value;
			},
			async set(value) {
				this.extend(extended => {
					extended.locationType = this.results.locationType.options.find(o => o.value === value);
					return extended;
				})
				if (!this.initialLocationType) {
					await this.executeSearch()
					this.deleteLocationTypeParam()
				};
			},
		},
	},
	methods: {
		clearAllFilters() {
			// visual reset
			// this.extended.location = ''
			// this.extended.locationType = this.extended.locationType[0]
			// this.extended.specialty = this.extended.specialty[0]

			// resubmission reset
			if(!(Object.keys(this.extended).length === 0)) {
				this.extend(extended => {
					extended = {}
					return extended
				})
				return this.executeSearch()
			}
		},
		selectInitialSpecialty() {
			const extendedSpecialty = this.extended.specialty
			// check for null as well
			if (extendedSpecialty && extendedSpecialty.value !== null) {
				let specialty = this.results.specialty.options.find(spec => spec.value.toLowerCase() === extendedSpecialty.value.toLowerCase()) || false;
				if (specialty) this.specialtyModel = extendedSpecialty.value
				else {
					this.specialtyModel = this.results.specialty.options[0].value
					this.deleteSpecialtyParam()
				}
			} else {
				this.specialtyModel = this.results.specialty.options[0].value
			}
			this.initialSpecialty = false;
		},
		// selectInitialLanguage() {
		// 	const extendedLanguage = this.extended.language
		// 	// check for null as well
		// 	if (extendedLanguage && extendedLanguage.value !== null) {
		// 		let language = this.results.language.options.find(spec => spec.value.toLowerCase() === extendedLanguage.value.toLowerCase()) || false;
		// 		if (language) this.languageModel = extendedLanguage.value
		// 		else {
		// 			this.languageModel = this.results.language.options[0].value
		// 			this.deleteSpecialtyParam()
		// 		}
		// 	} else {
		// 		this.languageModel = this.results.specialty.options[0].value
		// 	}
		// 	this.initialSpecialty = false;
		// },
		selectInitialLocationType() {
			const extendedLocationType = this.extended.locationType
			// check for null as well
			if (extendedLocationType && extendedLocationType.value !== null) {
				let locationType = this.results.locationType.options.find(lt => lt.value.toLowerCase() === extendedLocationType.value.toLowerCase()) || false;
				if (locationType) this.locatonTypeModel = extendedLocationType.value
				else {
					this.locationTypeModel = this.results.locationType.options[0].value
					this.deleteLocationTypeParam()
				}
			} else {
				this.locationTypeModel = this.results.locationType.options[0].value
			}
			this.initialLocationType = false;
		},
		deleteSpecialtyParam() {
			if (this.params.has("specialty")) {
				this.params.delete("specialty");
				this.url.search = this.params.toString();
				window.history.replaceState({}, "", this.url.href);
			}
		},
		deleteLocationTypeParam() {
			if (this.params.has("locationtype")) {
				this.params.delete("locationtype");
				this.url.search = this.params.toString();
				window.history.replaceState({}, "", this.url.href);
			}
		},
	},
	mounted() {
		this.url = new URL(window.location);
		this.params = new URLSearchParams(this.url.search);
		this.selectInitialSpecialty();
		//this.selectInitialLanguage();
		this.selectInitialLocationType();
	}
};
